@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
            <!-- Seletor de papel -->
            @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0) {
                <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                                [_isReadOnly]="$isReadOnly()"
                                [_papeis]="$papeisSelector()"
                                [_flowObjectType]="FlowObjectType.GatewayPaths"
                                (_signerIdChange)="signerIdChange($event)"
                ></papel-selector>
                <hr />
            }

            @if ($hasPendingTask()) {
                <!-- Task info: Iniciada -->
                @if ($shouldLetPublicAgentInteract()) {
                    <!-- Task footer: visão do executor -->
                    <div class="form-container">
                        <div class="mb-4">
                            <span>Escolha qual das Sequências de Tarefas configuradas no Admin deverá ser executada a seguir nesta Instância de Fluxo:</span>
                        </div>

                        <div class="footer">
                            <button type="button" class="btn btn-primary first path" (click)="submit(true)" (keyDown)="submit(true)">{{$configSchema().taskGatewayPaths.firstGatewayPathName}}</button>
                            <button type="button" class="btn btn-primary second path" (click)="submit(false)" (keyDown)="submit(false)">{{$configSchema().taskGatewayPaths.secondGatewayPathName}}</button>
                        </div>
                    </div>
                } @else {
                    <!-- Task body: visão do requerente -->
                    <div class="message-container">
                        <div class="mb-3">
                            Aguarde enquanto sua requisição se encontra em deliberação pelos servidores do seguinte local:
                        </div>
                        <div>
                            <span class="uppercase info-font text-highlight d-inline-block">{{$currentLocation()}}</span>
                        </div>
                    </div>
                }
            } @else {
                <!-- Task info: Realizada -->
                <div class="message-container">
                    <div class="mb-4">
                        <span>A seguinte Sequência de Tarefas configurada no Admin foi escolhida para o prosseguimento desta Instância de Fluxo:</span>
                    </div>

                    <div class="footer">
                        <button type="button" class="btn btn-primary path readonly" [ngClass]="$outputData().shouldFollowFirstGatewayPath ? 'first' : 'second'">{{$chosenGatewayPathName()}}</button>
                    </div>
                </div>
            }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
